module.exports = __webpack_public_path__ + "static/img/webdesign-01.68fac3c1.jpg";